var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "top-box", on: { click: _vm.iconClick } }, [
        _c("img", {
          staticClass: "imgsa",
          attrs: { src: _vm.imgUrls.url, alt: "" },
        }),
        _c("div", { staticClass: "use-title-box" }, [
          _c(
            "div",
            { staticClass: "use-d2" },
            [
              _c(
                "van-row",
                {
                  staticStyle: { padding: "10px 3%" },
                  attrs: { gutter: "20" },
                },
                [
                  _c(
                    "van-col",
                    {
                      staticClass: "van-col-title",
                      staticStyle: { display: "flex" },
                      attrs: { span: "12" },
                    },
                    [
                      _vm.userData.imageSrc == "" ||
                      _vm.userData.imageSrc == null
                        ? _c("img", {
                            staticClass: "use-img",
                            attrs: {
                              src: require("../../assets/image/userImage.png"),
                              alt: "",
                            },
                          })
                        : _c("img", {
                            staticClass: "use-img",
                            attrs: { src: _vm.userData.imageSrc, alt: "" },
                          }),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "use-d1" },
            [
              _c(
                "van-row",
                { staticStyle: { "padding-left": "8%" } },
                [
                  _c(
                    "van-col",
                    { staticClass: "van-col-titles", attrs: { span: "24" } },
                    [
                      _c("div", { staticClass: "use-size" }, [
                        _vm._v(_vm._s(_vm.userData.userName)),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "van-row",
                { staticStyle: { "padding-left": "9%", "padding-top": "5px" } },
                [
                  _c(
                    "van-col",
                    {
                      staticClass: "van-col-title",
                      staticStyle: {
                        color: "#fff",
                        "z-index": "10",
                        display: "flex",
                      },
                      attrs: { span: "24" },
                    },
                    [
                      _c("div", { staticStyle: { "z-index": "10" } }, [
                        _vm._v(_vm._s(_vm.userData.businessName)),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "use-d3" },
            [
              _c("van-icon", {
                attrs: { size: "24px", color: "#fff", name: "arrow" },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm.userData.auditStatus == 0
        ? _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "center",
                "align-items": "center",
              },
              on: { click: _vm.gotoAuth },
            },
            [
              _c("img", {
                staticStyle: { width: "90%" },
                attrs: {
                  src: require("../../assets/image/inviteAuth.png"),
                  alt: "",
                },
              }),
            ]
          )
        : _c("div", { staticClass: "d-box" }),
      _c("van-row", [_c("van-col", { attrs: { span: "" } })], 1),
      _c("van-cell", {
        attrs: { "is-link": "" },
        on: { click: _vm.collectClick },
        scopedSlots: _vm._u([
          {
            key: "icon",
            fn: function () {
              return [
                _c("div", { staticClass: "box" }, [
                  _c("img", {
                    staticClass: "collect-img-style",
                    attrs: {
                      src: require("../../assets/image/collect.png"),
                      alt: "",
                    },
                  }),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [
                _c("span", { staticClass: "custom-title" }, [
                  _vm._v("我的收藏"),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("van-cell", {
        attrs: { "is-link": "", icon: "shop-o" },
        on: { click: _vm.recipeClick },
        scopedSlots: _vm._u([
          {
            key: "icon",
            fn: function () {
              return [
                _c("div", { staticClass: "box" }, [
                  _c("img", {
                    staticClass: "collect-img-style",
                    attrs: {
                      src: require("../../assets/image/我的配方.png"),
                      alt: "",
                    },
                  }),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [
                _c("span", { staticClass: "custom-title" }, [
                  _vm._v("我的配方"),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("van-cell", {
        attrs: { "is-link": "", icon: "shop-o" },
        on: { click: _vm.myRecipeHistory },
        scopedSlots: _vm._u([
          {
            key: "icon",
            fn: function () {
              return [
                _c("div", { staticClass: "box" }, [
                  _c("img", {
                    staticClass: "collect-img-style",
                    attrs: {
                      src: require("../../assets/image/history.png"),
                      alt: "",
                    },
                  }),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [
                _c("span", { staticClass: "custom-title" }, [
                  _vm._v("历史记录"),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("van-cell", {
        attrs: { "is-link": "", value: _vm.pointBalance, icon: "shop-o" },
        on: { click: _vm.integralClick },
        scopedSlots: _vm._u([
          {
            key: "icon",
            fn: function () {
              return [
                _c("div", { staticClass: "box" }, [
                  _c("img", {
                    staticClass: "collect-img-style",
                    attrs: {
                      src: require("../../assets/image/我的积分.png"),
                      alt: "",
                    },
                  }),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [
                _c("span", { staticClass: "custom-title" }, [
                  _vm._v("我的积分"),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("van-cell", {
        attrs: { "is-link": "", icon: "shop-o" },
        on: { click: _vm.feedbackClick },
        scopedSlots: _vm._u([
          {
            key: "icon",
            fn: function () {
              return [
                _c("div", { staticClass: "box" }, [
                  _c("img", {
                    staticClass: "collect-img-style",
                    attrs: {
                      src: require("../../assets/image/feedback.png"),
                      alt: "",
                    },
                  }),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [
                _c("span", { staticClass: "custom-title" }, [
                  _vm._v("问题反馈"),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm.userData.inviteCodeEnabled == 1
        ? _c("van-cell", {
            attrs: { "is-link": "", icon: "shop-o" },
            on: { click: _vm.inviteCodeGener },
            scopedSlots: _vm._u(
              [
                {
                  key: "icon",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "box" }, [
                        _c("img", {
                          staticClass: "collect-img-style",
                          attrs: {
                            src: require("../../assets/image/invite.png"),
                            alt: "",
                          },
                        }),
                      ]),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("span", { staticClass: "custom-title" }, [
                        _vm._v("邀请码"),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1544485955
            ),
          })
        : _vm._e(),
      _c("van-cell", {
        attrs: { "is-link": "", icon: "shop-o" },
        on: { click: _vm.pushSetting },
        scopedSlots: _vm._u([
          {
            key: "icon",
            fn: function () {
              return [
                _c("div", { staticClass: "box" }, [
                  _c("img", {
                    staticClass: "collect-img-style",
                    attrs: {
                      src: require("../../assets/image/设置.png"),
                      alt: "",
                    },
                  }),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [
                _c("span", { staticClass: "custom-title" }, [_vm._v("设置")]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("Tabbar", { key: _vm.datekey, staticClass: "tab-style" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }